import styled from "styled-components";

import { ERROR } from "../../colors";
import { Body } from "../../typography";

export const FieldError = styled(Body).attrs({
  as: "div"
})`
  color: ${ERROR};
`;
